import { Component, Input } from '@angular/core';
import { ComponentView } from 'src/modules/app-template/models/component-view.model';
import { ProfilingEntry } from 'src/modules/enaio/shared/ProfilingEntry';
import { ProfilingSet } from 'src/modules/enaio/shared/ProfilingSet';
import { SmTimer } from 'src/modules/sm-base/models/sm-timer.model';
import { TableCellType } from 'src/modules/sm-base/models/table-cell-type.enum';
import { TableColumn } from 'src/modules/sm-base/models/table-column.model';
import { TableData } from 'src/modules/sm-base/models/table-data.model';
import { TableRow } from 'src/modules/sm-base/models/table-row.model';
import { TableSortColumn } from 'src/modules/sm-base/models/table-sort-column.model';
import { OrdinaryObject } from 'src/modules/utils/shared/ordinary-object.model';
import { Utils } from 'src/modules/utils/shared/utils';
import { DhTools } from '../../models/dh-tools.model';
import { TableCellButton } from 'src/modules/sm-base/models/table-cell-button.model';
import { TableCellEvent } from 'src/modules/sm-base/models/table-cell-event.model';

@Component({
  selector: 'app-document-handler-profiling',
  templateUrl: './document-handler-profiling.component.html',
  styleUrl: './document-handler-profiling.component.scss'
})
export class DocumentHandlerProfilingComponent extends ComponentView {

    @Input()
    guid: string = null;

    _useTimer = false;

    activeIndex = 0;

    workerProfilingRefresh = true;
    workerProfilingGroupObject = false;
    workerProfilingGroupWorker = false;
    enaioCallsProfilingRefresh = true;
    enaioCallsProfilingGroupParams = false;
    sqlProfilingRefresh = true;

    templateProfiling: ProfilingSet;
    enaioCallsProfiling: ProfilingSet;
    sqlProfiling: ProfilingSet;
    workerProfiling: ProfilingEntry[];
    tableTemplateProfiling: TableData;
    tableWorkerProfiling: TableData;
    tableEnaioCallsProfiling: TableData;
    tableSqlProfiling: TableData;
    debugTemplateCallStacks: OrdinaryObject<string> = {};
    requestedTemplateCallStacks: string[] = [];

    @Input()
    set useTimer(value: boolean) {
        if (value == this._useTimer) {
            return;
        }
        this._useTimer = value;
       /* if (this._useTimer) {
            this.addTimer(new SmTimer(0, 1_000, this.update.bind(this)));
        }
        else {
            throw new Error("Timer entfernen nicht implmementiert");
        }*/
    }

    async initParams(): Promise<boolean> {
        if (this._useTimer) {
            this.addTimer(new SmTimer(1000, 1000, this.update.bind(this), true));
        }
        return Promise.resolve(true);
    }

    async update(): Promise<void> {
        switch (this.activeIndex) {
            case 0:
                this.templateProfiling = await DhTools.backendCall("api/dhinstance/templateProfiling", { instanceGuid: this.guid }).get(ProfilingSet);
                await this.fillTemplateProfiling();
                break;
            case 1:
                if (this.workerProfilingRefresh) {
                    this.workerProfiling = await DhTools.backendCall("api/dhinstance/workerProfiling", { instanceGuid: this.guid }).list(ProfilingEntry);
                    this.fillWorkerProfilingTable();
                }
                break;
            case 2:
                if (this.enaioCallsProfilingRefresh) {
                    await this.fillEnaioCallsProfilingTable();
                }
                break;
            case 3:
                if (this.sqlProfilingRefresh) {
                    await this.fillSqlProfilingTable();
                }
                break;
        }
    }

    async fillTemplateProfiling(): Promise<void> {
        this.debugTemplateCallStacks = this.requestedTemplateCallStacks.length == 0 ? {} :
            Utils.fromJson(await DhTools.backendCall("api/dhinstance/templateCallStacks", { instanceGuid: this.guid }).getText());
        this.tableTemplateProfiling = TableData.update(this.tableTemplateProfiling, [
            new TableColumn("duration", "Dauer", TableCellType.durationNanos, { autoWidth: 1 }),
            new TableColumn("durationPerCall", "Dauer/Aufruf", TableCellType.durationNanos, { autoWidth: 1 }),
            new TableColumn("count", "Anzahl Aufrufe", TableCellType.int, { autoWidth: 7}),
            new TableColumn("template", "Template", TableCellType.text, { flex: 1 }),
            new TableColumn("requestCallStack", "Call Stack holen", TableCellType.yesNo, { autoWidth: 1, editable: true}),
            new TableColumn("callStack", "CallStack", TableCellType.button, { autoWidth: 1 })
        ], Utils.getOwnPropertyNames(this.templateProfiling.data).map(template => new TableRow(template, template, {
            duration: this.templateProfiling.data[template].nanos,
            durationPerCall: this.templateProfiling.data[template].nanos / this.templateProfiling.data[template].count,
            count: this.templateProfiling.data[template].count,
            template,
            requestCallStack: this.requestedTemplateCallStacks.includes(template),
            callStack: [new TableCellButton("display", "fas fa-eye", "Anzeigen", Utils.getSafe(this.debugTemplateCallStacks, template, "") != "")]
        })), [new TableSortColumn("duration", false)]);
    }

    fillWorkerProfilingTable(): void {
        let entries: ProfilingEntry[] = this.workerProfiling;
        if (this.workerProfilingGroupObject || this.workerProfilingGroupWorker) {
            entries = [];
            for (let p of this.workerProfiling) {
                let o = this.workerProfilingGroupWorker ? "<Alle>" : p.objectId;
                let w = this.workerProfilingGroupObject ? "<Alle>" : p.workerName;
                let e = entries.find(e2 => e2.objectId == o && e2.workerName == w);
                if (e == null) {
                    e = Utils.fromPlain(ProfilingEntry, {
                        objectId: o,
                        workerName: w,
                        nanos: 0
                    });
                    entries.push(e);
                }
                e.nanos += p.nanos;
            }
        }

        this.tableWorkerProfiling = TableData.update(this.tableWorkerProfiling, [
            new TableColumn("duration", "Dauer", TableCellType.durationNanos, { autoWidth: 1 }),
            new TableColumn("objectId", "Objekt", TableCellType.text, { autoWidth: 20 }),
            new TableColumn("workerName", "Worker", TableCellType.text, { autoWidth: 30}),
            new TableColumn("detail", "Detail", TableCellType.text, { flex: 1 })
        ], entries.map(p => new TableRow(p.objectId + "|" + p.workerName + "|" + p.detail, p, {
            objectId: p.objectId,
            workerName: p.workerName,
            detail: p.detail,
            duration: p.nanos
        })), [new TableSortColumn("duration", false)]);
    }

    async fillEnaioCallsProfilingTable(): Promise<void> {
        this.enaioCallsProfiling = await DhTools.backendCall("api/dhinstance/enaioCallsProfiling", { instanceGuid: this.guid, groupParams: this.enaioCallsProfilingGroupParams }).get(ProfilingSet);

        this.tableEnaioCallsProfiling = TableData.update(this.tableEnaioCallsProfiling, [
            new TableColumn("duration", "Dauer", TableCellType.durationNanos, { autoWidth: 1 }),
            new TableColumn("durationPerCall", "Dauer/Aufruf", TableCellType.durationNanos, { autoWidth: 1 }),
            new TableColumn("count", "Aufrufe", TableCellType.int, { autoWidth: 6 }),
            new TableColumn("call", "Aufruf", TableCellType.text, { flex: 1 })
        ], Utils.getOwnPropertyNames(this.enaioCallsProfiling.data).map(call => new TableRow(call, call, {
            call: Utils.stringRemovePrefix(call, "Enaio Server API Aufruf\n"),
            count: this.enaioCallsProfiling.data[call].count,
            duration: this.enaioCallsProfiling.data[call].nanos,
            durationPerCall: this.enaioCallsProfiling.data[call].nanos / this.enaioCallsProfiling.data[call].count
        })), [new TableSortColumn("duration", false)]);
    }

    async fillSqlProfilingTable(): Promise<void> {
        this.sqlProfiling = await DhTools.backendCall("api/dhinstance/sqlProfiling", { instanceGuid: this.guid }).get(ProfilingSet);

        this.tableSqlProfiling = TableData.update(this.tableSqlProfiling, [
            new TableColumn("duration", "Dauer", TableCellType.durationNanos, { autoWidth: 1 }),
            new TableColumn("durationPerCall", "Dauer/Aufruf", TableCellType.durationNanos, { autoWidth: 1 }),
            new TableColumn("count", "Aufrufe", TableCellType.int, { autoWidth: 6 }),
            new TableColumn("key", "Schlüssel", TableCellType.text, { flex: 1 })
        ], Utils.getOwnPropertyNames(this.sqlProfiling.data).map(call => new TableRow(call, call, {
            key: call,
            count: this.sqlProfiling.data[call].count,
            duration: this.sqlProfiling.data[call].nanos,
            durationPerCall: this.sqlProfiling.data[call].nanos / this.sqlProfiling.data[call].count
        })), [new TableSortColumn("duration", false)]);
    }

    async editTemplateProfilingCell(event: TableCellEvent): Promise<void> {
        if (event.column.colId == "requestCallStack") {
            let template = event.row.raw as string;
            let request = event.row.values.requestCallStack as boolean;
            this.requestedTemplateCallStacks = Utils.arraySetContained(this.requestedTemplateCallStacks, template, request);
            await DhTools.backendCall("api/dhinstance/templateRequestCallStack", {instanceGuid: this.guid, template, request}).getString();
        }
    }

    clickTemplateProfilingCell(event: TableCellEvent): void {
        if (event.isButton("display", "callStack")) {
            this.app.messageDialog.textArea("Call Stack", this.debugTemplateCallStacks[event.row.raw as string], null, true);
        }
    }

}
